// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./Assets/fonts/Poppins-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./Assets/fonts/Poppins-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./Assets/fonts/Poppins-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./Assets/fonts/Poppins-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./Assets/fonts/Poppins-Bold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "PoppinsLight";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}
@font-face {
  font-family: "PoppinsRegular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@font-face {
  font-family: "PoppinsMedium";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
}
@font-face {
  font-family: "PoppinsSemiBold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
}
@font-face {
  font-family: "PoppinsBold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
}`, "",{"version":3,"sources":["webpack://./src/Poppins.scss"],"names":[],"mappings":"AACA;EACI,2BAAA;EACA,+DAAA;AAAJ;AAGE;EACE,6BAAA;EACA,4CAAA;AADJ;AAIE;EACE,4BAAA;EACA,+DAAA;AAFJ;AAKE;EACE,8BAAA;EACA,+DAAA;AAHJ;AAME;EACE,0BAAA;EACA,+DAAA;AAJJ","sourcesContent":["\n@font-face {\n    font-family: 'PoppinsLight';\n    src: url('./Assets/fonts/Poppins-Light.ttf') format(\"truetype\");\n  }\n  \n  @font-face {\n    font-family: 'PoppinsRegular';\n    src: url('./Assets/fonts/Poppins-Regular.ttf');\n  }\n  \n  @font-face {\n    font-family: 'PoppinsMedium';\n    src: url('./Assets/fonts/Poppins-Medium.ttf') format(\"truetype\");\n  }\n  \n  @font-face {\n    font-family: 'PoppinsSemiBold';\n    src: url('./Assets/fonts/Poppins-SemiBold.ttf') format(\"truetype\"); \n  }\n  \n  @font-face {\n    font-family: 'PoppinsBold';\n    src: url('./Assets/fonts/Poppins-Bold.ttf') format(\"truetype\");   \n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
